import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

/**
 * Translation files keep the same URL on every build, and older deploys served
 * them as `immutable` for a year, so browsers would keep a stale copy forever.
 * Deploys now upload them as `no-cache`; this query string moves every browser
 * off the old cached URL once. Bump it only if that caching ever recurs.
 */
const TRANSLATION_CACHE_VERSION = 2;
@Injectable({
  providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader {
  private _httpClient = inject(HttpClient);
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * Get translation
   *
   * @param lang
   */
  getTranslation(lang: string): Observable<Translation> {
    return this._httpClient.get<Translation>(
      `./assets/i18n/${lang}.json?v=${TRANSLATION_CACHE_VERSION}`
    );
  }
}
